/** @format */

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ListBulletsIcon } from "@phosphor-icons/react/dist/ssr/ListBullets";

export interface TasksProgressProps {
	sx?: SxProps;
	value: number;
}

export function TotalCircles({
	value,
	sx,
}: TasksProgressProps): React.JSX.Element {
	return (
		<Card sx={sx}>
			<CardContent>
				<Stack spacing={2}>
					<Stack
						direction="row"
						sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
						spacing={3}>
						<Stack spacing={1}>
							<Typography
								color="text.secondary"
								gutterBottom
								variant="overline">
								Total Circles
							</Typography>
							<Typography variant="h4">{value}</Typography>
						</Stack>
						<Avatar
							sx={{
								backgroundColor: "warning.main",
								height: "56px",
								width: "56px",
							}}>
							<ListBulletsIcon size={24} color="#ffffff" />
						</Avatar>
					</Stack>
					
				</Stack>
			</CardContent>
		</Card>
	);
}
